import React, { Component, useEffect, useLayoutEffect, useState } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from "react-scroll-up";
import FooterTwo from "../component/footer/FooterTwo";
import logoXrai from "../assets/images/logo/logo_xrai.png";

import Scrollspy from "react-scrollspy";
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import { Link } from "react-router-dom";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import FishService from "./service/FishService";
import OcrService from "./service/OcrSercive";
import HealthService1 from "./service/HealthService1";
import FontService from "./service/FontService";
import HealthService2 from "./service/HealthService2";
import HealthService3 from "./service/HealthService3";
import "../assets/css/custom.css";
import HealthService4 from "./service/HealthService4";
import HealthService5 from "./service/HealthService5";
import { removeCookie } from "../util/Cookie";
import { TokenName } from "../util/Common";
import { useSetRecoilState } from "recoil";
import { apiKeyState } from "../atom/ApiKey";
import { apiProductsState } from "../atom/Products";
import { ListJoinState } from "../atom/BorderPage";
const ServiceDetails = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const [service, setService] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [selectedButton, setSelectedButton] = useState("간편인증");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const subMenuMap = {
    간편인증: [
      "카카오 간편인증 요청",
      "카카오 간편인증 확인",
      "네이버 간편인증 요청",
      "네이버 간편인증 확인",
    ],
    공동인증서인증: ["공동인증서 등록", "공동인증서 로그인"],
    질환예측: [],
    CAPTCHA인증: ["CAPTCHA 이미지 호출", "CAPTCHA 인증 시도"],
    건강검진내역조회: ["건강검진 내역 조회", "검진현황서비스 연동"],
  };

  const handleSelectMenu = (label, target) => {
    setSelectedButton(label);
    setService(target);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const { hash } = location;
    if (hash) {
      const target = hash.substring(1);
      setService(target);
      if (target) {
        setService(target);
      }
    }
  }, [location]);

  const openModal = () => {
    setIsOpen(true);
  };

  const logo = {
    width: "25%",
  };

  const handleSelectMenu2 = (label, classNameOrId) => {
    const isSub = classNameOrId.startsWith("sub-");

    if (isSub) {
      const targetElement = document.querySelector(`.${classNameOrId}`);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else {
      console.log("상위 메뉴 클릭:", label);
    }
  };
  const [isToken, setToken] = useState(false);
  const setListJoinState = useSetRecoilState(ListJoinState);

  const history = useHistory();
  const setApiKeys = useSetRecoilState(apiKeyState);
  const setPriducts = useSetRecoilState(apiProductsState);
  const haderLogout = () => {
    localStorage.clear();
    setApiKeys([]);
    setPriducts([]);
    setListJoinState([]);
    removeCookie(TokenName);
    history.push("/login");
  };
  return (
    <React.Fragment>
      {/* Start Pagehelmet  */}
      <PageHelmet pageTitle="Service Details" />
      {/* End Pagehelmet  */}

      {/* <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        /> */}
      <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div
              className="logo"
              style={{ width: windowWidth <= 850 ? "350px" : "100%" }}
            >
              <a href="/">
                <img
                  className="logo-1"
                  style={logo}
                  src={logoXrai}
                  alt="Logo Images"
                />
                <img className="logo-2" src={logoXrai} alt="Logo Images" />
              </a>
            </div>
          </div>

          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <Scrollspy
                className="mainmenu"
                items={[
                  "home",
                  "company",
                  "solution",
                  "portfolio",
                  // "blog",
                  "contact",
                ]}
                currentClassName="is-current"
                offset={-200}
              >
                <li>
                  <a href="/#home">Home</a>
                </li>
                <li>
                  <a href="/#company">Company</a>
                </li>
                <li>
                  <a href="/#solution">Solution</a>
                </li>
                <li>
                  <a href="/#portfolio">Portfolio</a>
                </li>

                <li>
                  <a href="/border">Contact</a>
                </li>
                <li>
                  {isToken === false ? (
                    <a href="login">Login</a>
                  ) : (
                    <a
                      style={{
                        cursor: `pointer`,
                      }}
                      onClick={() => haderLogout()}
                    >
                      Logout
                    </a>
                  )}
                </li>
              </Scrollspy>
            </nav>
          </div>
          {windowWidth <= 990 && (
            <div
              style={{ height: `100%`, cursor: `pointer` }}
              onClick={() => setIsSidebarOpen(true)}
            >
              <FiMenu size={30} />
            </div>
          )}
        </div>
      </header>
      {isSidebarOpen && (
        <>
          {/* 배경 클릭 시 닫히는 오버레이 */}
          <div
            className="sidebar-overlay"
            onClick={() => setIsSidebarOpen(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 999, // 사이드바보다 뒤에 있으면 안 됨
            }}
          />

          {/* 사이드바 영역 */}
          <div
            className="sidebar"
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              width: "40vw",
              height: "100vh",
              backgroundColor: "#fff",
              zIndex: 1000,
              boxShadow: "-2px 0 8px rgba(0,0,0,0.2)",
              padding: "20px",
              transition: "transform 0.3s ease-in-out",
            }}
          >
            <div style={{ textAlign: "right", marginBottom: "20px" }}>
              <button
                onClick={() => setIsSidebarOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>

            {/* 메뉴 내용 */}
            <ul style={{ listStyle: "none", padding: 0, fontSize: "18px" }}>
              <li>
                <a style={{ fontSize: `25px` }} href="/#home">
                  Home
                </a>
              </li>
              <li>
                <a style={{ fontSize: `25px` }} href="/#company">
                  Company
                </a>
              </li>
              <li>
                <a style={{ fontSize: `25px` }} href="/#solution">
                  Solution
                </a>
              </li>
              <li>
                <a style={{ fontSize: `25px` }} href="/#portfolio">
                  Portfolio
                </a>
              </li>
              <li>
                <a style={{ fontSize: `25px` }} href="/#contact">
                  Contact
                </a>
              </li>
              <hr color="#FFAA77" style={{ marginTop: `10px` }} />
              {[
                "간편인증",
                "공동인증서 인증",
                "질환예측",
                "건강검진 내역 조회",
              ].map((label, index) => {
                const subMenus = subMenuMap[label.replace(/ /g, "")] || [];
                const isSelected = selectedButton === label;
                return (
                  <li
                    key={index}
                    style={{ marginBottom: "20px", cursor: "pointer" }}
                    onClick={() =>
                      handleSelectMenu(label, `health-${index + 1}`)
                    }
                  >
                    <div
                      className="sidMenuText"
                      style={{
                        color: selectedButton === label ? "#FFC20E" : "black",
                        fontWeight:
                          selectedButton === label ? "bold" : "normal",
                      }}
                    >
                      {label}
                    </div>

                    {isSelected && subMenus.length > 0 && (
                      <div className="subMenuContainer">
                        {subMenus.map((sub, subIndex) => (
                          <div
                            className="sidMenuSubButton2"
                            key={subIndex}
                            onClick={() =>
                              handleSelectMenu2(sub, `sub-${subIndex}`)
                            }
                          >
                            <div
                              style={{
                                width: `20px`,
                                marginTop: `5px`,
                                marginBottom: `5px`,
                              }}
                            >
                              {subIndex + 1}.
                            </div>{" "}
                            <div
                              style={{
                                marginTop: `5px`,
                                marginBottom: `5px`,
                              }}
                            >
                              {sub}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </li>
                );
              })}
              <hr color="#FFAA77" />
            </ul>
          </div>
        </>
      )}

      {/* End Breadcrump Area */}

      {/* Start Page Wrapper */}
      <div className="rn-service-details ptb--120 bg_color--1">
        <div style={{ display: `flex`, marginTop: `30px`, marginLeft: `20px` }}>
          {windowWidth >= 990 &&
            [
              "health-1",
              "health-2",
              "health-3",
              "health-4",
              "health-5",
            ].includes(service) && (
              <div className="fixedBox">
                {[
                  "간편인증",
                  "공동인증서 인증",
                  "질환예측",
                  "CAPTCHA 인증",
                  "건강검진 내역 조회",
                ].map((label, index) => {
                  const subMenus = subMenuMap[label.replace(/ /g, "")] || [];
                  const isSelected = selectedButton === label;
                  return (
                    <div
                      className="fixedMenu"
                      style={{
                        backgroundColor:
                          selectedButton === label ? "#FFC20E" : "white",
                        color: selectedButton === label ? "white" : "black",
                      }}
                      key={index}
                    >
                      <div
                        className="fixedButton"
                        onClick={() =>
                          handleSelectMenu(label, `health-${index + 1}`)
                        }
                      >
                        {label}
                      </div>

                      {isSelected && subMenus.length > 0 && (
                        <div className="subMenuContainer">
                          {subMenus.map((sub, subIndex) => (
                            <div
                              className="sidMenuSubButton"
                              key={subIndex}
                              onClick={() =>
                                handleSelectMenu2(sub, `sub-${subIndex}`)
                              }
                            >
                              <div
                                style={{
                                  width: `20px`,
                                  marginTop: `5px`,
                                  marginBottom: `5px`,
                                }}
                              >
                                {subIndex + 1}.
                              </div>{" "}
                              <div
                                style={{
                                  marginTop: `5px`,
                                  marginBottom: `5px`,
                                }}
                              >
                                {sub}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      <div
                        className="fixedHr"
                        style={{
                          backgroundColor:
                            selectedButton === label ? "#FFAA77" : "gray",
                        }}
                      ></div>
                    </div>
                  );
                })}
              </div>
            )}
          <div className="container">
            <div className="row">
              <div className="col-lg-10">
                <div className="service-details-inner">
                  <div className="inner">
                    {/* Start Single Area */}
                    {service === "fishDetection" && <FishService></FishService>}
                    {service === "Ocr" && <OcrService />}
                    {service === "font" && <FontService />}
                    {service === "health-1" && <HealthService1 />}
                    {service === "health-2" && <HealthService2 />}
                    {service === "health-3" && <HealthService3 />}
                    {service === "health-4" && <HealthService4 />}
                    {service === "health-5" && <HealthService5 />}
                    {/* End Single Area */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Page Wrapper */}

      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}

      <FooterTwo />
    </React.Fragment>
  );
};

export default ServiceDetails;
